import {z} from '@hono/zod-openapi';

/**
 * The Alpha envelope the search, statistics, redirect, preview and pricing operations pass
 * through. Its keys depend on the Alpha operation behind them, so it is documented open and
 * never used to parse.
 */
export const priceReportAlphaEnvelopeResponseSchema = z
  .object({})
  .passthrough()
  .openapi('PriceReportAlphaEnvelopeResponse');
